window.ZBIORNIK_COMMUNICATION_STATE_STATUS = [
    [Const.ZBIORNIK_COMMUNICATION_STATE_STATUS_ACTIVE, Lang.active],
    [Const.ZBIORNIK_COMMUNICATION_STATE_STATUS_SHORT_INACTIVITY, Lang.nie_komunikuje_sie_krotki_czas],
    [Const.ZBIORNIK_COMMUNICATION_STATE_STATUS_LONG_INACTIVITY, Lang.nie_komunikuje_sie_dlugo],
    [Const.ZBIORNIK_COMMUNICATION_STATE_STATUS_INACTIVE, Lang.w_komunikacji_recznej]
];

window.SKP_TYPES = [
    [Const.TYPE_SKP_SKP, Lang.skp],
    [Const.TYPE_SKP_SKPULITE, Lang.skpulite]
];

window.SKP_SONDA_TYPES = [
    [Const.TYPE_SKP_SONDA_ANALOG, Lang.sonda_analogowa],
    [Const.TYPE_SKP_SONDA_KELLER_PR26X_MSP100, Lang.sonda_keller_pr26x_msp100],
    [Const.TYPE_SKP_SONDA_APLISENS_SG25_MODBUS_MSP100, Lang.sonda_aplisens_sg25_modbus_msp100]
];

window.TYP_POJAZDU = [
    [Const.TYP_POJAZDU_WEWNETRZNY, Lang.wewnetrzny],
    [Const.TYP_POJAZDU_ZEWNETRZNY, Lang.zewnetrzny]
];

window.TYP_WLASNOSCI_POJAZDU = [
    [Const.TYP_WLASNOSCI_POJAZDU_WLASNY, Lang.wlasny],
    [Const.TYP_WLASNOSCI_POJAZDU_WYNAJEM, Lang.wynajem]
];

window.TYP_TABORU = [
    [Const.TYP_TABORU_KOMUNIKACYJNY, Lang.komunikacyjny],
    [Const.TYP_TABORU_NIEKOMUNIKACYJNY, Lang.niekomunikacyjny],
    [Const.TYP_TABORU_ZAKLADOWY, Lang.zakladowy]
];

window.TYP_KATEGORII = [
    [Const.TYP_KATEGORII_MOTOGODZINY, Lang.motogodziny],
    [Const.TYP_KATEGORII_KILOMETRY, Lang.kilometry],
    [Const.TYP_KATEGORII_MANUALNY, Lang.manualny]
];

window.TYP_KATEGORII_ONLY_KM = [
    [Const.TYP_KATEGORII_KILOMETRY, Lang.kilometry]
];

window.TYP_OPERACJI_ZDARZENIE = [
    [Const.TYP_OPERACJI_ZDARZENIE_DOLEWKA, Lang.dolewka],
    [Const.TYP_OPERACJI_ZDARZENIE_NAPRAWA_BIEZACA, Lang.naprawa_biezaca],
    [Const.TYP_OPERACJI_ZDARZENIE_OBSLUGA_TECHNICZNA, Lang.obsluga_techniczna],
    [Const.TYP_OPERACJI_ZDARZENIE_NAPRAWA_GWARANCYJNA, Lang.naprawa_gwarancyjna],
    [Const.TYP_OPERACJI_ZDARZENIE_NAPRAWA_WYPADKOWA, Lang.naprawa_wypadkowa],
    [Const.TYP_OPERACJI_ZDARZENIE_OPIS_NIE_DOTYCZY, Lang.opis_nie_dotyczy],
    [Const.TYP_OPERACJI_ZDARZENIE_POGOTOWIE_TECHNICZNE, Lang.pogotowie_techniczne]
];

window.NAPELNIANY_UKLAD = [
    [Const.NAPELNIANY_UKLAD_SILNIK, Lang.silnik],
    [Const.NAPELNIANY_UKLAD_DOZOWNIK_OLEJU, Lang.dozownik_oleju],
    [Const.NAPELNIANY_UKLAD_NAPED_WENTYLATORA, Lang.naped_wentylatora],
    [Const.NAPELNIANY_UKLAD_SKRZYNIA_BIEGOW, Lang.skrzynia_biegow],
    [Const.NAPELNIANY_UKLAD_MOST_NAPEDOWY, Lang.most_napedowy],
    [Const.NAPELNIANY_UKLAD_UKLAD_CHLODZENIA, Lang.uklad_chlodzenia],
    [Const.NAPELNIANY_UKLAD_UKLAD_HYDRAULICZNY, Lang.uklad_hydrauliczny],
    [Const.NAPELNIANY_UKLAD_SPRYSKIWACZ_SZYB, Lang.spryskiwacz_szyb],
    [Const.NAPELNIANY_UKLAD_POGOTOWIE_TECHNICZNE, Lang.pogotowie_techniczne],
    [Const.NAPELNIANY_UKLAD_PALIWOWY, Lang.paliwowy]
];

window.PODTYP_USER_ZDARZENIA = [
    [Const.TANKOWANIE_UZYTKOWNIKA_ZEWNETRZNE_PODTYP, Lang.tankowanie_zewnetrzne],
    [Const.TANKOWANIE_UZYTKOWNIKA_WEWNETRZNE_PODTYP, Lang.tankowanie_wewnetrzne]
];

window.PODTYP_USER_ZDARZENIA_SKROT = [
    [Const.TANKOWANIE_UZYTKOWNIKA_ZEWNETRZNE_PODTYP, Lang.tankowanie_zewnetrzne_skrot],
    [Const.TANKOWANIE_UZYTKOWNIKA_WEWNETRZNE_PODTYP, Lang.tankowanie_wewnetrzne_skrot]
];

window.TRYB_ZBIORNIKA_DATA = [
    [Const.TRYB_ZBIORNIKA_OPROZNIANY, Lang.tryb_zbiornika_oprozniany],
    [Const.TRYB_ZBIORNIKA_NAPELNIANY, Lang.tryb_zbiornika_napelniany]
];

window.OPERATOR_ROLES_DATA = [
    [Const.OPERATOR_P_SERWIS, Lang.serwis],
    [Const.OPERATOR_P_ADMIN, Lang.administrator],
    [Const.OPERATOR_P_OPERATOR, Lang.operator],
    [Const.OPERATOR_P_RAPORT, Lang.raport],
    [Const.OPERATOR_P_DOSTAWCA, Lang.dostawca],
    [Const.OPERATOR_P_CLOUD, Lang.cloud],
    [Const.OPERATOR_P_API, Lang.api],
    [Const.OPERATOR_P_CUSTOM, Lang.custom_permissions],
    [Const.OPERATOR_P_SKP, Lang.skp]
];

window.MANUALLYENTERED = [
    [Const.MANUALENTERED_NO_MATCH, Lang.brak_dopasowania],
    [Const.MANUALENTERED_ODBIORCA_MATCH, Lang.dopasowano_odbiorce],
    [Const.MANUALENTERED_ODBIORCA_CREATED, Lang.utworzono_odbiorce],
    [Const.MANUALENTERED_ODBIORCA_NO_MATCH, Lang.nie_udalo_sie_dopasowac_odbiorcy],
    [Const.MANUALENTERED_POJAZD_MATCH, Lang.dopasowano_pojazd],
    [Const.MANUALENTERED_POJAZD_CREATED, Lang.utworzono_pojazd],
    [Const.MANUALENTERED_POJAZD_NO_MATCH, Lang.nie_udalo_sie_dopasowac_pojazdu]
];